import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {CommonService} from '../../services/common.service';
import {ExportCsvService} from '../../services/export-csv.service';
import {MatDialog} from '@angular/material/dialog';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {SalePointPlirotisDialogComponent} from './sale-point-plirotis-dialog/sale-point-plirotis-dialog.component';
import {ToastMessagesService} from '../../services/toast-messages.service';
import {UploadSalePointPlirotisDialogComponent} from './upload-sale-point-plirotis-dialog/upload-sale-point-plirotis-dialog.component';
import {LoadingService} from "../../services/loading.service";

@Component({
  selector: 'app-sale-point-plirotis',
  templateUrl: './sale-point-plirotis.component.html'
})
export class SalePointPlirotisComponent implements OnInit, AfterViewInit {
  @ViewChild(MatSort, {static: false}) sort: MatSort;

  models: any[];
  salePointPlirotis: MatTableDataSource<any> = new MatTableDataSource<any>();
  displayPartColumns = ['plirotis_code', 'plirotis_name', 'vat_number'];
  loading: boolean;

  constructor(private commonService: CommonService,
              private exportCsvService: ExportCsvService,
              private loadingService: LoadingService,
              private matDialog: MatDialog,
              private toastMessagesService: ToastMessagesService) {
  }

  ngOnInit(): void {
    this.loading = true;
    this.loadingService.hide();
  }

  async ngAfterViewInit(): Promise<void> {
    await this.initModels();
    this.salePointPlirotis.sort = this.sort;
  }

  applyFilter(filterValue: string) {
    this.salePointPlirotis.filter = filterValue.trim().toLowerCase();
  }

  browseFiles() {
    const dialog = this.matDialog.open(UploadSalePointPlirotisDialogComponent, {});
    dialog.afterClosed().subscribe(async () => {
      await this.initModels();
    });
  }

  exportExcel() {
    const {data, columns} = this.formatExcelModel();
    this.exportCsvService.exportAsCustomExcelFile(data, 'salePointPlirotis', columns);
  }

  formatExcelModel() {
    const data = [];
    for (const record of this.salePointPlirotis.data) {
      const model = {
        plirotis_code: record.plirotis_code,
        plirotis_name: record.plirotis_name,
        vat_number: record.vat_number
      };
      data.push(model);
    }

    const columns = [{
      key: 'plirotis_code',
      label: 'Κωδικός Πληρωτή',
    }, {
      key: 'plirotis_name',
      label: 'Επωνυμία Πληρωτή',
    }, {
      key: 'vat_number',
      label: 'Α.Φ.Μ.',
    }
    ];

    return {data, columns};
  }

  async initModels() {
    try {
      this.loading = true;
      this.models = await this.commonService.getSimpleList('sale_point_plirotis') as any[];
      this.salePointPlirotis = new MatTableDataSource<any>(this.models);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    } finally {
      this.loading = false;
    }
  }

  async showPlirotisDialog() {
    const dialog = this.matDialog.open(SalePointPlirotisDialogComponent, {
      width: '450'
    });

    dialog.afterClosed().subscribe(async (result) => {
      let insertData;
      if (result) {
        insertData = {
          plirotis_code: result.plirotis_code,
          plirotis_name: result.plirotis_name,
          vat_number: result.vat_number
        };
        try {
          this.loading = true;
          await this.commonService.insertObjectForAutomations('sale_point_plirotis', insertData);
          this.loading = false;
          await this.initModels();
          this.toastMessagesService.toastInsertSuccess();
        } catch (e) {
          this.toastMessagesService.toastErrorMessage(e.error);
          this.loading = false;
        }
      }
    });
  }
}
